export const GOOGLE_STORE_MX = 'https://dolarapp.onelink.me/TKY0/npitnou3'
export const GOOGLE_STORE_AR = 'https://dolarapp.onelink.me/TKY0/guooh8al'
export const GOOGLE_STORE_CO = 'https://dolarapp.onelink.me/TKY0/4dzon1xh'
export const GOOGLE_STORE_BR = 'https://dolarapp.onelink.me/TKY0/ni0b6s2p'

export const APPLE_STORE_MX = 'https://dolarapp.onelink.me/TKY0/7vjenhde'
export const APPLE_STORE_AR = 'https://dolarapp.onelink.me/TKY0/rck3wi9r'
export const APPLE_STORE_CO = 'https://dolarapp.onelink.me/TKY0/9xvpl28l'
export const APPLE_STORE_BR = 'https://dolarapp.onelink.me/TKY0/r7prz8pk'

export const UNIVERSAL_MOBILE_LINK = 'https://dolarapp.onelink.me/TKY0/j010p26r'

export const BUSINESS_APP_URL = `https://business.dolarapp.com/sign-up`
export const BUSINESS_LOG_IN_URL = `https://business.dolarapp.com/sign-in`
export const CALENDLY_URL =
  'https://meetings.hubspot.com/juvenal-garnica/dolarapp-business'

export const RETAIL_APP_CARDS_DEEP_LINK = `https://dolarapp.onelink.me/dusx/5oymnlpl`

export const DONATE_MX_DEEP_LINK = `https://dolarapp.onelink.me/TKY0/478arl83`
export const DONATE_CO_DEEP_LINK = `https://dolarapp.onelink.me/TKY0/ucwi0dow`
